module.exports = {
	"_from": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
	"_id": "cw-unified-inbox@2.4.4",
	"_inBundle": false,
	"_integrity": "",
	"_location": "/cw-unified-inbox",
	"_phantomChildren": {
		"@babel/runtime": "7.24.5",
		"classnames": "2.5.1",
		"htmlparser2": "3.10.1",
		"prop-types": "15.8.1",
		"react-popper": "1.3.11",
		"react-transition-group": "2.9.0"
	},
	"_requested": {
		"type": "git",
		"raw": "cw-unified-inbox@git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
		"name": "cw-unified-inbox",
		"escapedName": "cw-unified-inbox",
		"rawSpec": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
		"saveSpec": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
		"fetchSpec": "ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git",
		"gitCommittish": "2.4.4"
	},
	"_requiredBy": [
		"#USER",
		"/"
	],
	"_resolved": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#e8e62e73f3ec4ca6bd2767d90f236bdb4d175f1a",
	"_spec": "cw-unified-inbox@git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
	"_where": "C:\\jenkis\\.jenkins\\workspace\\CW_RELEASE\\P\\CW_Galatea_Agent_UI_RELEASE",
	"bundleDependencies": false,
	"dependencies": {
		"date-fns": "2.28.0",
		"escape-html": "1.0.3",
		"global-components-library": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-components-library.git#1.98.0",
		"i18next": "19.9.2",
		"react-html-parser": "2.0.2",
		"react-i18next": "11.15.3",
		"react-input-emoji": "4.0.9",
		"reactstrap": "8.10.0",
		"slate": "^0.78.0",
		"slate-react": "^0.79.0"
	},
	"deprecated": false,
	"devDependencies": {
		"@babel/cli": "7.16.8",
		"@babel/preset-env": "7.16.11",
		"@babel/preset-react": "7.16.7",
		"@storybook/addon-actions": "^5.3.21",
		"@storybook/addon-knobs": "^5.3.21",
		"@storybook/addon-links": "^5.3.21",
		"@storybook/addon-storyshots": "^5.3.21",
		"@storybook/addons": "^5.3.22",
		"@storybook/preset-create-react-app": "^2.1.2",
		"@storybook/react": "^5.3.21",
		"check-prop-types": "1.1.2",
		"cross-env": "7.0.3",
		"css-loader": "3.4.2",
		"enzyme": "3.11.0",
		"enzyme-adapter-react-16": "1.15.6",
		"eslint": "6.8.0",
		"eslint-plugin-react": "7.28.0",
		"jest-cli": "^25.5.4",
		"node-sass": "4.14.1",
		"node-sass-chokidar": "1.5.0",
		"prettier": "2.5.1",
		"react": "16.14.0",
		"react-dom": "16.14.0",
		"react-scripts": "3.4.1",
		"react-test-renderer": "16.14.0",
		"storybook-addon-i18n": "^5.1.13"
	},
	"eslintConfig": {
		"extends": "react-app"
	},
	"files": [
		"dist"
	],
	"homepage": "https://bitbucket.org/nuxibatechnologies/cw-unified-inbox#readme",
	"jest": {
		"coverageReporters": [
			"json",
			"html",
			"text",
			"cobertura"
		],
		"collectCoverageFrom": [
			"src/**/*.{js,jsx}",
			"!**/node_modules/**",
			"!**/output/**",
			"!**/build/**",
			"!**/public/**",
			"!**/coverage/**",
			"!src/index.js",
			"!src/i18n.js"
		],
		"coverageThreshold": {
			"global": {
				"branches": 80,
				"functions": 80,
				"lines": 80,
				"statements": -10
			}
		}
	},
	"main": "dist/index.js",
	"name": "cw-unified-inbox",
	"peerDependencies": {
		"node-sass": "4.13.1"
	},
	"prettier": {
		"printWidth": 200,
		"tabWidth": 2,
		"useTabs": true,
		"semi": true,
		"singleQuote": true,
		"trailingComma": "none",
		"bracketSpacing": true,
		"jsxBracketSameLine": true,
		"jsxSingleQuote": true,
		"arrowParens": "avoid",
		"proseWrap": "always"
	},
	"private": true,
	"repository": {
		"type": "git",
		"url": "git+https://bitbucket.org/nuxibatechnologies/cw-unified-inbox.git"
	},
	"scripts": {
		"build-css": "node-sass-chokidar ./src/styles/bundle.scss -o ./src/styles/css",
		"build-storybook": "build-storybook",
		"clean": "rimraf dist",
		"compile": "npm run build-css && npm run clean && cross-env NODE_ENV=production babel src --out-dir dist --copy-files --no-copy-ignored --ignore __tests__,src/**/*.spec.js,src/**/*.test.js,src/stories,src/test,src/setupTests.js,__snapshots__",
		"format": "prettier --write \"**/*.+(js|jsx|json|css|md)\"",
		"storybook": "start-storybook -p 9009",
		"test": "react-scripts test --coverage --watchAll=true --coverageDirectory=output/coverage",
		"testsingle": "react-scripts test"
	},
	"version": "2.4.4"
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/package.json
// module id = 2042
// module chunks = 0